import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongDetailsLessonNonPlayActionNonMember.module.scss";
import Button from "../../../../../../components/common/Button";
import navigation from "../../../../../../services/navigation/navigation";

export interface ISongDetailsLessonNonPlayActionNonMemberProps {
  lessonId: number | string;
}

export const SongDetailsLessonNonPlayActionNonMember: VoidFunctionComponent<ISongDetailsLessonNonPlayActionNonMemberProps> = ({lessonId}) => {
  return (
    <div className={s.container}>
      <div className={s.songPrompt}>
        <Button buttonType={"secondary"} text={'Purchase'} additionalClassName={s.songAction} onClick={() => navigation.goToExternalPlaygroundSongStoreLesson(lessonId)} />
        <div className={s.details}>
          Complete purchase on our website
        </div>
      </div>
    </div>
  );
}

